import { callingObject as receiverObjects, computedFunctions } from "./schema";
export const renderLiquid = (rule)=>{
    const output = rule.conditions.map((condition)=>renderCondition(condition)).join(" " + rule.operator + " ");
    return output;
};
export const operatorsWithoutRHS = [
    "t",
    "f",
    "null",
    "nnull"
];
const renderCondition = (condition)=>{
    return `${renderLHS(condition.lhs)} ${renderOperator(condition.operator)} ${operatorsWithoutRHS.includes(condition.operator) ? "" : renderRHS(condition.rhs)}`.trim();
};
const renderOperator = (operator)=>{
    switch(operator){
        case "t":
            return "== true";
        case "f":
            return "== false";
        case "eq":
            return "==";
        case "neq":
            return "!=";
        case "gt":
            return ">";
        case "gte":
            return ">=";
        case "lt":
            return "<";
        case "lte":
            return "<=";
        case "c":
            return "contains";
        case "null":
            return "== null";
        case "nnull":
            return "!= null";
    }
};
const renderLHS = (lhs)=>{
    return lhs.value;
};
const renderRHS = (rhs)=>{
    switch(rhs.type){
        case "number":
            return rhs.value.toString();
        case "boolean":
            return rhs.value.toString();
        case "string":
            return `"${rhs.value}"`;
        case "computed_function":
            return rhs.value;
        case "property":
            return rhs.value;
    }
};
const mapOperatorToCEL = (operator)=>{
    switch(operator){
        case "and":
            return "&&";
        case "or":
            return "||";
        default:
            return operator;
    }
};
export const _renderCEL = (rule)=>{
    const output = rule ? rule.conditions.map((condition)=>renderCELCondition(condition)).join(" " + mapOperatorToCEL(rule.operator) + " ") : undefined;
    const entitlements = (rule === null || rule === void 0 ? void 0 : rule.entitlements) || {
        rule: {
            type: "no_active_entitlements"
        },
        type: "entitlement"
    };
    const entitlement = renderCELEntitlementCondition(entitlements.rule);
    if (output) {
        if (entitlement) {
            return `(${entitlement}) && (${output})`;
        }
        return output;
    } else {
        return entitlement;
    }
};
export const renderCEL = (rule)=>{
    const output = _renderCEL(rule);
    return output === "" ? null : output;
};
// Renders Condition values as CEL expressions, with properties being converted to computed functions where necessary
const renderCELValue = (value)=>{
    switch(value.type){
        case "computed_function":
            return value.value;
        case "property":
            {
                let parsed = createCELFunctionFromProperty(value.value);
                if (parsed) {
                    return parsed.value;
                } else {
                    return value.value;
                }
            }
        case "number":
            return value.value.toString();
        case "boolean":
            return value.value.toString();
        case "string":
            return `"${value.value}"`;
    }
};
const renderCELCondition = (condition)=>{
    let left = renderCELValue(condition.lhs);
    let right = ()=>renderCELValue(condition.rhs);
    switch(condition.operator){
        case "t":
            return `${left} == true`;
        case "f":
            return `${left} == false`;
        case "eq":
            return `${left} == ${right()}`;
        case "neq":
            return `${left} != ${right()}`;
        case "gt":
            return `${left} > ${right()}`;
        case "gte":
            return `${left} >= ${right()}`;
        case "lt":
            return `${left} < ${right()}`;
        case "lte":
            return `${left} <= ${right()}`;
        case "c":
            return `${left}.contains(${right()})`;
        case "null":
            return `${left} == null`;
        case "nnull":
            return `${left} != null`;
    }
};
const renderCELEntitlementCondition = (condition)=>{
    const activeIdentifiers = condition.type === "entitlement_conditions" ? condition.conditions.filter((x)=>x.status === "active").map((x)=>x.identifier) : [];
    const inactiveIdentifiers = condition.type === "entitlement_conditions" ? condition.conditions.filter((x)=>x.status === "inactive").map((x)=>x.identifier) : [];
    const containsActive = activeIdentifiers.length > 0 ? `${JSON.stringify(activeIdentifiers)}.all(identifier, device.activeEntitlements.contains(identifier))` : "";
    const containsInactive = inactiveIdentifiers.length > 0 ? `${JSON.stringify(inactiveIdentifiers)}.all(identifier, !device.activeEntitlements.contains(identifier))` : "";
    switch(condition.type){
        case "no_active_entitlements":
            return "size(device.activeEntitlements) == 0";
        case "entitlement_conditions":
            const parts = [
                containsActive,
                containsInactive
            ].filter((x)=>x);
            return parts.join(" && ");
        case "always_true":
            return "";
    }
};
export const createCELFunctionFromProperty = (property)=>{
    if (property.indexOf(".") === -1 || property.indexOf("_") === -1) return undefined;
    const parts = property.split(".");
    // If it starts with one of the defined groups, then it is a computed property function
    let group = parts.shift();
    let receiver = receiverObjects.safeParse(group);
    if (receiver.success) {
        // The receiver object of the function
        let remaining = parts[0].split("_");
        // Check if it is one of the predefined computed functions
        let functionName = remaining.shift();
        let parsedFunction = computedFunctions.safeParse(functionName);
        if (parsedFunction.success) {
            //It is a computed property function, we take the name and rejoin the rest as arguments
            let args = remaining.join("_");
            return {
                type: "computed_function",
                caller: receiver.data,
                name: parsedFunction.data,
                args: args,
                value: `${receiver.data}.${parsedFunction.data}("${args}")`
            };
        } else {
            // It is a property - return undefined
            return undefined;
        }
    } else {
        // Since it has no receiver object, it is definitely just a property - return undefined
        return undefined;
    }
};
